import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { useHeaderColorSet } from './MainNavigation.styles';
import SvgSearch from '../../../../../play-core/icons/Search';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { useSearchDispatch } from '../../../pages/Search/SearchContext';
import { Button } from '../../ClickableComponents/Button';
import { Text } from '../../IconText/IconText';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchButton = ({
  searchFieldRef
}) => {
  const {
    t
  } = useTranslation();
  const searchDispatch = useSearchDispatch();
  const colorSet = useHeaderColorSet();
  return /*#__PURE__*/_jsx(StyledButton, {
    type: "text",
    text: t('global.search'),
    size: "small",
    colorSet: colorSet,
    onClick: () => {
      searchDispatch({
        type: 'toggle'
      });

      // We have to focus the search input within this click handler, because iOS
      // devices only allow to focus an input and open the keyboard from an event handler.
      searchFieldRef.current && searchFieldRef.current.focus();
    },
    icon: /*#__PURE__*/_jsx(SvgSearch, {
      "data-testid": "global-search-button"
    })
  });
};
const StyledButton = styled(Button).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "SearchButton__StyledButton",
  componentId: "sc-hwv2wu-0"
})(["", "{", "{display:none;}}"], Viewports.for('mediumDown'), Text);